import DashboardStore from "../DashboardStore";
import React, { FC, useEffect, useState } from "react";
import { PieChart, Pie, Cell } from "recharts";
import { observer } from "mobx-react";
import PieChartIcon from "../../../../../../images/activity-dashboard/pie-chart-slate-blue.svg";
import {  DashboardService } from "../../../shared/services";
import {
  AuthService,
  CustomLabel,
  FlexContainer,
  Loader,
  ToastService,
} from "@mindmemobile/mm-shared-global";
import { ItemBreakDownGraphModel } from "../../../shared/models";
import { CustomLine } from "../../../shared/styles";
import { ColorBox } from "../../../shared/components";
import { AccountSettingsStore } from "../../../shared/store";

type IProps = {
  dashboardStore: DashboardStore;
  merchantAccountId: string;
};
const ItemBreakDownWidget: FC<IProps> = ({
  dashboardStore,
  merchantAccountId,
}) => {
  const [showLoader, setLoader] = useState(true);
  useEffect(() => {
    if (!merchantAccountId) return;
    setLoader(true);
    DashboardService.itemBreakDowns(
      AuthService.authData.accountId,
      merchantAccountId
    ).subscribe({
      next: (response) => {
        setLoader(false);
        const mappedData = ItemBreakDownGraphModel.deserializeAPIModel(
          response.result
        );
        dashboardStore.updateItemBreakDownGraph(mappedData);
      },
      error: () => {
        setLoader(false);
        ToastService.showError("Error Occured");
      },
    });
  }, [merchantAccountId]);

  if (showLoader || !dashboardStore.itemBreakDownGraphData)
    return <>{new Loader(true, "", "447px").loaderComponent}</>;

  const data = [
    {
      label: "Product",
      value: dashboardStore.itemBreakDownGraphData.product,
      color: "#CCC8E7",
    },
    {
      label: "Service",
      value: dashboardStore.itemBreakDownGraphData.service,
      color: "#555555",
    },
    {
      label: "Membership",
      value: dashboardStore.itemBreakDownGraphData.membership,
      color: "#FF9E80",
    },
    {
      label: "Donation",
      value: dashboardStore.itemBreakDownGraphData.donation,
      color: "#B0F4D3",
    },
  ];

  const totalValue = data.reduce((sum, entry) => sum + entry.value, 0);

  const updatedData =
    totalValue === 0 ? data.map((entry) => ({ ...entry, value: 0.01 })) : data;

  return (
    <>
      {" "}
      <FlexContainer
        justifyContent="space-between"
        className="activity-header-wrapper"
      >
        <div>
          <FlexContainer
            alignItems="center"
            spacing={10}
            padding="0px 0px 30px"
          >
            <img src={PieChartIcon} alt="pie" />
            <div className="activity-card-header">Item Breakdown</div>
          </FlexContainer>
        </div>
      </FlexContainer>
      <PieChart width={288} height={170}>
        <Pie
          data={updatedData}
          cx="50%"
          cy="50%"
          labelLine={false}
          // innerRadius={60}
          outerRadius={80}
          fill="#8884d8"
          dataKey="value"
        >
          {updatedData.map((entry, index) => (
            <Cell key={`cell-${index}`} fill={entry.color} />
          ))}
        </Pie>
      </PieChart>
      <FlexContainer justifyContent="space-between" padding="20px 0px 10px">
        <CustomLabel>Category</CustomLabel>
        <CustomLabel>Total Amount</CustomLabel>
      </FlexContainer>
      <CustomLine width="100%" bgColor="#ccc" height="1px" />
      {data.map((entry, index) => {
        return (
          <FlexContainer
            key={index}
            justifyContent="space-between"
            padding="20px 0px 0px"
          >
            <div>
              <FlexContainer spacing={10} alignItems="center">
                <ColorBox
                  heightWidth="20px"
                  borderRadius="0px"
                  bgColor={entry.color}
                />
                <CustomLabel className="breakdown-label">
                  {entry.label}
                </CustomLabel>
              </FlexContainer>
            </div>
            <CustomLabel className="overflow-ellipsis">
              ${AccountSettingsStore.formatAmount(entry.value, true)}
            </CustomLabel>
          </FlexContainer>
        );
      })}
    </>
  );
};

export default observer(ItemBreakDownWidget);
